export default "__VITE_ASSET__DvFmJUKL__"